export default "__VITE_ASSET__tWDe_cOt__"